import { AxiosRequestConfig } from 'axios'

export interface AppSettings {
  id: number
  reviewCooldownDays?: number
  reviewGoogleMinStars?: number
  reviewEmailDelayMinutes?: number
  reviewPushDelayMinutes?: number
  reviewAlertMaxStars?: number
  reviewAutoReplyMinStars?: number
}

export interface GetSettingsResponse {
  settings: AppSettings
}

const getAppSettings = (): AxiosRequestConfig => ({
  url: '/settings',
  method: 'GET',
})

const patchAppSettings = (payload: {
  reviewCooldownDays?: number
  reviewGoogleMinStars?: number
  reviewEmailDelayMinutes?: number
  reviewPushDelayMinutes?: number
  reviewAlertMaxStars?: number
  reviewAutoReplyMinStars?: number
}): AxiosRequestConfig => ({
  url: '/settings',
  method: 'PATCH',
  data: payload,
})

export { getAppSettings, patchAppSettings }
